// UI Store - Estado de la interfaz (sidebar, modales, tema, etc.)
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ThemeMode = 'light' | 'dark' | 'system';

interface UIStore {
  sidebarExpanded: boolean;
  theme: ThemeMode;
  onboardingDismissed: boolean;
  toggleSidebar: () => void;
  setSidebarExpanded: (expanded: boolean) => void;
  setTheme: (theme: ThemeMode) => void;
  dismissOnboarding: () => void;
}

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      sidebarExpanded: true,
      theme: 'system' as ThemeMode,
      onboardingDismissed: false,
      toggleSidebar: () => set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),
      setSidebarExpanded: (expanded: boolean) => set({ sidebarExpanded: expanded }),
      setTheme: (theme: ThemeMode) => set({ theme }),
      dismissOnboarding: () => set({ onboardingDismissed: true }),
    }),
    {
      name: 'ui-preferences', // localStorage key
      storage: createJSONStorage(() => localStorage),
    }
  )
);
